<template>
    <div class="modal-dialog">
        <div class="card">
            <div class="modal-content">
                <div class="modal-header border-0">
                   
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                        @click="fermer"></button>
                </div>

                <div class="modal-body text-center pt-4 pb-4">
                     <h5 class="modal-title mb-4">
                        {{ $t("date_sequence.title") }} {{ currentStep }}/{{ totalSteps }}
                    </h5>
                    <!-- Step Progress Indicator -->
                    <div class="step-indicator mb-4">
                        <div class="d-flex justify-content-center">
                            <div v-for="step in totalSteps" :key="step"
                                :class="['step-dot mx-2', { active: step === currentStep }]">
                                {{ step }}
                            </div>
                        </div>
                    </div>

                    <div class="container mt-3">
                        <form class="mb-4">
                            <div class="mx-auto" style="width: 84%;">

                                <!-- Step 1: Sequences and Niveaux -->
                                <div v-show="currentStep === 1">
                                    <div class="mb-3 text-start">
                                        <label for="sequences" style="font-size:14px" class="form-label">
                                            {{ $t("date_sequence.label1") }} <em style="color: #f60000">*</em>
                                        </label>

                                        <div class="row mt-3 ps-3">
                                            <div v-for="sequence in sequences" :key="sequence.id"
                                                class="form-check col-3 mt-2">

                                                <input class="form-check-input" type="radio" name="sequence"
                                                    :id="`sequence-${sequence.id}`" :value="sequence.name"
                                                    v-model="selectedSequence"
                                                    :class="{ 'is-invalid': formSubmitted && !selectedSequence }">
                                                <label class="form-check-label" :for="`sequence-${sequence.id}`">
                                                    {{ sequence.name }}
                                                </label>
                                            </div>
                                            <div class="invalid-feedback d-block"
                                                v-if="formSubmitted && !selectedSequence">
                                                {{ $t("date_sequence.error1") }}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="mb-3 text-start">
                                        <label class="form-label">
                                            {{ $t("date_sequence.label2") }} <em style="color: #f60000">*</em>
                                        </label>

                                        <div class="row mt-3 ps-3">
                                            <div v-for="item in GRADE_CODE" :key="item.code"
                                                class="form-check col-3 mt-2">
                                                <input class="form-check-input" type="checkbox"
                                                    :id="`matiere-${item.code}`" :value="item.name"
                                                    v-model="selectedlevel"
                                                    :class="{ 'is-invalid': formSubmitted && selectedlevel.length === 0 }">
                                                <label class="form-check-label" :for="`matiere-${item.code}`">
                                                    {{ item.name }}
                                                </label>
                                            </div>

                                            <div class="invalid-feedback d-block"
                                                v-if="formSubmitted && selectedlevel.length === 0">
                                                {{ $t("date_sequence.error2") }}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Step 2: Dates (formerly Step 3) -->
                                <div v-show="currentStep === 2">
                                    <div class="row mt-5">
                                        <div class="mb-3 col-6 text-start">
                                            <label for="startDate" class="form-label">
                                                {{ $t("date_sequence.label4") }} <em style="color: #f60000">*</em>
                                            </label>
                                            <input style="height:50px;" type="date" class="form-control" id="input"
                                                v-model="startDate"
                                                :class="{ 'is-invalid': formSubmitted && !startDate }">
                                            <div class="invalid-feedback d-block" v-if="formSubmitted && !startDate">
                                                {{ $t("date_sequence.error4") }}
                                            </div>
                                            <div class="invalid-feedback d-block" v-if="!isDateValid">
                                                {{ $t("temporary_suspension.error") }}
                                            </div>
                                        </div>
                                        <div class="mb-3 col-6 text-start">
                                            <label for="endDate" class="form-label">
                                                {{ $t("date_sequence.label5") }} <em style="color: #f60000">*</em>
                                            </label>
                                            <input style="height:50px;" type="date" class="form-control" id="input"
                                                v-model="endDate" :class="{ 'is-invalid': formSubmitted && !endDate }">
                                            <div class="invalid-feedback d-block" v-if="formSubmitted && !endDate">
                                                {{ $t("date_sequence.error5") }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

                <div class="modal-footer border-0 pb-5 mb-1">
                    <argon-button v-if="currentStep > 1" @click="previousStep" type="button" class="btn"
                        style="width: 200px; height: 50px; padding-top: 15px; background: none; border: 1px solid rgba(255, 255, 255, 0.4);">
                        {{ $t("button.previous") }}
                    </argon-button>

                    <argon-button v-if="currentStep < totalSteps" @click="nextStep" type="button" class="btn me-7"
                        color="success" variant="gradient" style="width: 200px; height: 50px; padding-top: 15px"
                        :disabled="!canProceedToNextStep || loading">
                        <span v-if="loading && currentStep === 1">Chargement...</span>
                        <span v-else>{{ $t("button.next") }}</span>
                    </argon-button>

                    <argon-button v-if="currentStep === totalSteps" @click="sendAlert" type="button" class="btn me-7"
                        color="success" variant="gradient" style="width: 200px; height: 50px; padding-top: 15px"
                        :loading="loading" :active="buttonActive || showConfirmation" :clickEvent="button">
                        <span v-if="!loading">{{ $t("button.send") }}</span>
                    </argon-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ArgonButton from "@/components/ArgonButton";
import { getGrades, postNoteAvailable, getAlertSubscribers } from "@/utils/services";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";

// Import Bootstrap si nécessaire (optionnel)
let Bootstrap = null;
try {
    Bootstrap = require('bootstrap');
} catch (error) {
    // Bootstrap n'est pas installé comme module, utiliser window.bootstrap
    console.log('Bootstrap sera utilisé depuis window.bootstrap');
}

export default {
    name: 'Sequence-Modal',
    components: {
        ArgonButton,
    },
    emits: ['close'], // Déclarer l'événement émis
    data() {
        return {
            currentStep: 1,
            totalSteps: 2,
            selectedSequence: '',
            startDate: '',
            endDate: '',
            sequences: [
                { id: 1, name: this.$t('grade_available.seq1') },
                { id: 2, name: this.$t('grade_available.seq2') },
                { id: 3, name: this.$t('grade_available.seq3') },
                { id: 4, name: this.$t('grade_available.seq4') },
                { id: 5, name: this.$t('grade_available.seq5') },
                { id: 6, name: this.$t('grade_available.seq6') }
            ],
            selectedlevel: [],
            selectedNiveau: [],
            loading: false,
            classroomId: null,
            showAlert: false,
            grade_code: '',
            grade_name: '',
            GRADE_CODE: [],
            isChoiceMade: false,
            formSubmitted: false,
            buttonActive: false,
            showConfirmation: false,
            registrationNumber: [],
            school_id: '',
        };
    },

    mounted() {
        this.school_id = localStorage.getItem("schoolId");
    },
    computed: {
        isDateValid() {
            if (this.startDate && this.endDate) {
                return new Date(this.startDate) < new Date(this.endDate);
            }
            return true;
        },
        canProceedToNextStep() {
            if (this.currentStep === 1) {
                return this.selectedSequence !== '' && this.selectedlevel.length > 0;
            }
            return false;
        }
    },

    methods: {
        fermer() {
            this.selectedSequence = '';
            this.selectedlevel = [];
            this.startDate = '';
            this.endDate = '';
            this.currentStep = 1;
            this.formSubmitted = false;
        },

        // Méthode pour fermer automatiquement tous les modals
        closeModal() {
            // Fermer tous les modals Bootstrap ouverts
            this.closeAllBootstrapModals();
            
            // Réinitialiser les données du composant
            this.fermer();
        },

        // Fermer tous les modals Bootstrap en cours
        closeAllBootstrapModals() {
            try {
                // Obtenir la référence Bootstrap
                const BootstrapRef = Bootstrap || window.bootstrap;
                
                // Méthode 1: Fermer tous les modals avec la classe .modal.show
                const openModals = document.querySelectorAll('.modal.show');
                openModals.forEach(modal => {
                    if (BootstrapRef && BootstrapRef.Modal) {
                        const modalInstance = BootstrapRef.Modal.getInstance(modal);
                        if (modalInstance) {
                            modalInstance.hide();
                        }
                    }
                    // Alternative: déclencher l'événement de fermeture manuellement
                    else {
                        const closeBtn = modal.querySelector('[data-bs-dismiss="modal"]');
                        if (closeBtn) {
                            closeBtn.click();
                        }
                    }
                });
            } catch (error) {
                console.warn('Erreur lors de la fermeture des modals Bootstrap:', error);
            }

            // Méthode 2: Forcer la fermeture en supprimant les classes et backdrop
            document.querySelectorAll('.modal').forEach(modal => {
                modal.classList.remove('show');
                modal.style.display = 'none';
                modal.setAttribute('aria-hidden', 'true');
                modal.removeAttribute('aria-modal');
            });

            // Supprimer tous les backdrops de modal
            document.querySelectorAll('.modal-backdrop').forEach(backdrop => {
                backdrop.remove();
            });

            // Restaurer le scroll du body
            document.body.classList.remove('modal-open');
            document.body.style.overflow = '';
            document.body.style.paddingRight = '';

            // Déclencher l'événement de fermeture pour le composant parent
            this.$emit('close');
        },

        async getData() {
            this.loading = true;
            let grades = await getGrades();
            this.GRADE_CODE = grades.data;
            this.grade_code = grades.data[0].name;
            this.grade_name = grades.data[0].name;
            this.loading = false;
        },

        async nextStep() {
            this.formSubmitted = true;
            if (this.currentStep === 1) {
                if (this.selectedlevel.length === 0 || this.selectedSequence === '') {
                    return;
                }
                this.loading = true;
                try {
                    // Get registration numbers for each selected grade
                    const allRegistrationNumbers = [];
                    
                    for (const gradeName of this.selectedlevel) {
                        // Find the grade code from GRADE_CODE array
                        const grade = this.GRADE_CODE.find(g => g.name === gradeName);
                        if (grade) {
                            const response = await getAlertSubscribers(grade.code, '', 'ESKAALERT');
                            if (response.status === 200 && response.data) {
                                allRegistrationNumbers.push(...response.data);
                            }
                        }
                    }
                    
                    // Remove duplicates
                    this.registrationNumber = [...new Set(allRegistrationNumbers)];
                    if (this.registrationNumber.length === 0) {
                        toast.error("Aucun abonné trouvé pour ce(s) niveau(x).", { autoClose: 3000 });
                        this.loading = false;
                        return;
                    }
                    this.currentStep = 2;
                } catch (error) {
                    toast.error("Erreur lors de la récupération des matricules des élèves", {
                        autoClose: 3000,
                    });
                } finally {
                    this.loading = false;
                }
            }

            this.formSubmitted = false;
        },

        previousStep() {
            if (this.currentStep === 2) {
                this.currentStep = 1;
            }
        },

        async sendAlert() {
            this.formSubmitted = true;
            if (this.loading) {
                return
            }

            if (!this.startDate || !this.endDate) {
                return;
            }

            this.loading = true;

            try {
                // Create detailed message with all information
                const gradeNames = this.selectedlevel.join(', ');
                const data = {
                    school_id: this.school_id,
                    code: 4102,
                    registration_number_list: this.registrationNumber,
                    sequence: this.selectedSequence,
                    start_date: this.startDate,
                    end_date: this.endDate,
                    // Include detailed information for message display
                    reason_list: [
                        `Séquence: ${this.selectedSequence}`,
                        `Niveaux: ${gradeNames}`,
                        `Date de début: ${this.startDate}`,
                        `Date de fin: ${this.endDate}`
                    ]
                };

                const response = await postNoteAvailable(data);

                if (response.status === 200) {
                    const message = this.$t("date_sequence.success_message");
                    toast.success(message, {
                        autoClose: 3000,
                    });

                    // Fermer automatiquement tous les modals après un délai
                    setTimeout(() => {
                        this.closeModal();
                    }, 1500); // Attendre 1.5 secondes après le toast
                } else {
                    // En cas d'échec, juste réinitialiser sans fermer
                    this.fermer();
                }
            } catch (error) {
                toast.error("Erreur lors de l'envoi de la notification", {
                    autoClose: 3000,
                });
            } finally {
                this.loading = false;
            }
        }
    },
    beforeMount() {
        this.getData();
    },
};
</script>

<style>
.step-indicator .step-dot {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
}

.step-indicator .step-dot.active {
    background: #5e72e4;
}

#pending,
#settled {
    text-align: justify;
    margin-left: auto;
    margin-right: auto;
    padding: 8px;
    border: 1px solid green;
}

#alert-modal {
    border: 1px solid #83454d;
    color: #83454d;
    background: rgba(0, 0, 0, 0.6)
}

input[type="date"]::-webkit-calendar-picker-indicator,
input[type="time"]::-webkit-calendar-picker-indicator {
    filter: invert(1);
}

.is-invalid {
    border-color: #dc3545 !important;
    border-width: 1px;
}
</style>